// Kept out of form_helpers.js so it can be unit tested without a DOM: that file registers its
// listeners on import, this one only acts on the elements it is handed.
//
// Shows the elements of `selector` inside the toggle's `data-toggle-scope` ancestor, and hides the
// others. `has-hidden` alone would not be enough: a hidden element stays part of the form, so a
// `required` input could block a submit it is no longer concerned by, and a hidden value would
// still reach the server. `disabled` takes it out of the submitted params too.
export function toggleScope(toggle, selector, shown) {
  toggle
    .closest("[data-toggle-scope]")
    .querySelectorAll(selector)
    .forEach((el) => {
      const visible = shown(el);
      el.classList.toggle("has-hidden", !visible);
      el.disabled = !visible;
    });
}
